import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

export async function getVehicles({
  page = 1,
  pageSize = 10,
  filter = "",
  sorting,
  nissanVehicleStatus,
  nissanDropShipStatus,
}) {
  const currentPage = page - 1;

  const SkipCount = currentPage * pageSize;
  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    Status: nissanVehicleStatus || undefined,
    IsDropship: nissanDropShipStatus,
    sorting,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/vehicles`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function changeStatusVehicle(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/vehicles/change-status`, {
    method: "PATCH",
    data: params,
  });
  return result?.data;
}
